import type { AccountManagementTypes } from '../generated';

/**
 * Whether an account is managed by Adobe — either an Adobe enterprise
 * organization or a Creative Cloud Individual (CCI) subscription.
 *
 * Replaces the deprecated `managedByAdobe` boolean field.
 */
export const isAccountAdobeManaged = (
  managedBy: AccountManagementTypes | null | undefined
): boolean => managedBy === 'ADOBE_ENTERPRISE' || managedBy === 'ADOBE_CCI';
